const ArrayUtil = {
    /***
     * Finds the index in a sorted array, where the value at that index is closest to the target value
     * @param arr - sorted array of numbers, target - target number
     * @returns closestIndex - index of arr, where the value at that index is closest to the target value
     * if there are two equal distant values, the lower index is returned
     */
    findClosest(arr, target) {
        let length = arr.length,
            closestIndex = -1;

        if (target <= arr[0]) {
            closestIndex = 0;
        } else if (target >= arr[length - 1]) {
            closestIndex = length - 1;
        } else {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === target) {
                    closestIndex = i;
                    break;
                } else if (i + 1 < arr.length) {
                    if (target >= arr[i] && target <= arr[i + 1]) {
                        closestIndex = Math.abs(target - arr[i]) <= Math.abs(arr[i + 1] - target) ? i : i + 1;
                        break;
                    }
                }
            }
        }

        return closestIndex;
    },

    findClosest2Points(
        arr,
        target,
        formatter = (e) => {
            return e;
        }
    ) {
        let length = arr.length,
            closestPoints = {
                beforeIndex: -1,
                afterIndex: -1
            };

        for (let i = 0; i < length; i++) {
            if (target === formatter(arr[i])) {
                closestPoints.beforeIndex = i;
                closestPoints.afterIndex = i;
                break;
            } else if (i + 1 < length) {
                if (target >= formatter(arr[i]) && target <= formatter(arr[i + 1])) {
                    if (target === formatter(arr[i])) {
                        closestPoints.beforeIndex = i;
                        closestPoints.afterIndex = i;
                    } else if (target === formatter(arr[i + 1])) {
                        closestPoints.beforeIndex = i + 1;
                        closestPoints.afterIndex = i + 1;
                    } else {
                        closestPoints.beforeIndex = i;
                        closestPoints.afterIndex = i + 1;
                    }
                    break;
                }
            }
        }
        return closestPoints;
    },

    removeNulls(array) {
        return array.filter((item) => item !== null);
    },

    fillNulls(array) {
        let len = array.length,
            copy = [],
            i;

        for (i = 0; i < len; i++) {
            if (array[i] === null) {
                if (i === 0) {
                    copy.push(0);
                } else {
                    // go back until we find a non null value
                    let foundItem = null,
                        n = 0;
                    for (n = i; n > 0; n--) {
                        if (array[n] !== null) {
                            foundItem = array[n];
                            break;
                        }
                    }
                    for (; n <= i; n++) {
                        copy[n] = foundItem;
                    }
                }
            } else {
                copy.push(array[i]);
            }
        }

        return copy;
    },

    groupBy(array, key) {
        return array.reduce((result, currentValue) => {
            // Get the value to group by (either from object property or function result)
            const groupKey = typeof key === 'function' ? key(currentValue) : currentValue[key];

            // If the key doesn't exist in result, initialize it with an empty array
            if (!result[groupKey]) {
                result[groupKey] = [];
            }

            // Push the current value to the group
            result[groupKey].push(currentValue);

            return result;
        }, {});
    }
};

export default ArrayUtil;
